<div class="o-d-cards-container">
	<div class="o-d-card">
		<div class="row" *ngIf="document && document.metadata">
			<div class="col">
				<p class="name">{{ document?.metadata?.filename }}</p>
				<span>{{ document?.metadata?.uploadedDate | date }}</span>
			</div>
			<div class="col">
				<p class="results">{{ document?.metadata?.description }}</p>
			</div>
			<div class="col">
				<app-document-actions [document]="document"></app-document-actions>
			</div>
		</div>
	</div>
</div>
